import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  categories: [],
  category: {
    id: 0,
    category: "",
    status: true,
    userName: ""
  },
  categoryValidation: {
    isValid: true,
    topic: {
      isValid: true,
      errorMessage: "El campo tema no debe estar vacio",
    },
    shortdescription: {
      isValid: true,
      errorMessage: "El campo descripción corta no debe estar vacio",
    },
    type: {
      isValid: true,
      errorMessage: "El campo tipo no debe estar vacio",
    },
    categoryid: {
      isValid: true,
      errorMessage: "El campo categoría no debe estar vacio",
    },
    description: {
      isValid: true,
      errorMessage: "El campo descripción no debe estar vacio",
    },
    format: {
      isValid: true,
      errorMessage: "El campo formato no debe estar vacio",
    },
    duration: {
      isValid: true,
      errorMessage: "El campo duración no debe estar vacio",
    },
    price: {
      isValid: true,
      errorMessage: "El campo precio no debe estar vacio",
    },
    startDate: {
      isValid: true,
      errorMessage: "El campo fecha de inicio no debe estar vacio",
    },
    endDate: {
      isValid: true,
      errorMessage: "El campo fecha de fin no debe estar vacio",
    },
    startTime: {
      isValid: true,
      errorMessage: "El campo hora de inicio no debe estar vacio",
    },
    endTime: {
      isValid: true,
      errorMessage: "El campo hora de fin no debe estar vacio",
    },
    imageUrl: {
      isValid: true,
      errorMessage: "Debes cargar una imagen",
    },
    brochureUrl: {
      isValid: true,
      errorMessage: "Debes cargar un brochure",
    },
    zoomUrl: {
      isValid: true,
      errorMessage: "Debes cargar un zoom",
    },
    days: {
      isValid: true,
      errorMessage: "El campo días no debe estar vacio",
    },
  },
};

const categorySlice = createSlice({
    name: "category",
    initialState,
    reducers: {
      restartState(state) {
        state.category = {};
        state.categories = [];
      },
      setCategories(state, actions) {
        state.categories = actions.payload.categories;
        state.category = {};
      },
      setCategory(state, actions) {
        state.category = actions.payload.category;
        state.categories = [];
      },
      modifyPropertyValue(state, actions) {
        state.category[actions.payload.id] = actions.payload.value;
      },
      setCategoryValidation(state, actions) {
        state.categoryValidation = {
          category: {
            ...state.categoryValidation.category,
            isValid: actions.payload.category !== "",
          },
         
        };
        state.categoryValidation.isValid =
          state.categoryValidation.description.isValid;
      },
      setFieldValid(state, actions) {
        state.categoryValidation[actions.payload.id].isValid = actions.payload.value;
      },
    },
  });

  
export const categoryActions = categorySlice.actions;
export default categorySlice;